import { useEffect, useState } from "react";
import LoaderImg from "@assets/images/loader.gif";
import { toast } from "react-toastify";
import { getApiUrl } from "@utils/baseUrl";
import axios from "axios";
import { useSelector } from "react-redux";
import LocalStorageService from "@core/services/local-storage.service";

const componentData = {
  due_diligence_reports: {
    imgLink: "https://res.cloudinary.com/drzta9shk/image/upload/v1755755566/intel/misc/due_diligence_basic_plan_yqferz.svg",
    buttonText: "Upgrade Your Plan",
    contentHeader: "Strategic Advantages of Due Diligence",
    lists: ["Shareholder and Key Personnel information", "Financial and credit analysis", "Legal and compliance checks", "Certifications and Ratings", "Ownership and management details"],
  },
  corporate_heirarchy: {
    imgLink: "https://res.cloudinary.com/drzta9shk/image/upload/v1755689975/intel/misc/corporate_as5jsd.svg",
    buttonText: "Upgrade Your Plan",
    contentHeader: "Insights You Gain from Corporate Hierarchy",
    lists: ["Identify subsidiaries across regions easily", "Understand corporate structure and operations", "Connect faster with the right entity", "Analyze market presence by region"],
  },
};

const FeatureBlockUI = ({ activePanelId }) => {
  const creditDetails = useSelector((state) => state.userDetails.creditDetails);
  const country = creditDetails?.data[0]?.user_active_plan;
  const planId = LocalStorageService.getUserCurrentPlan();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, [activePanelId]);

  const handleUpgrade = () => {
    setLoading(true);
    const params = {
      planId: planId ? planId : "",
      countries: country,
      key: activePanelId,
    };

    axios
      .get(getApiUrl("notifySales"), { params })
      .then((res) => {
        if (!!res && !!res.data && !!res.data.status && res.data.status.toUpperCase() === "success".toUpperCase()) {
          toast.success(res.data.message);
        } else {
          toast.error(res.data.message ? res.data.message : "Something went wrong. Please try again later !!!");
        }
      })
      .catch(() => {
        toast.error("Something went wrong. Please try again later !!!");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div className="tw-h-full tw-flex tw-justify-center tw-items-center">
      {loading ? (
        // adjust the below margin-top and keep it at center
        <div className="tw-h-full tw-flex tw-justify-center tw-items-center tw-mt-32">
          <img src={LoaderImg} alt="description of gif" />
        </div>
      ) : (
        <div className="tw-flex tw-justify-center tw-gap-4">
          <div>
            <img src={componentData[activePanelId].imgLink} />
          </div>
          <div className="tw-flex tw-flex-col tw-gap-4">
            <span className="tw-flex tw-flex-col tw-gap-2">
              <span className="tw-text-base tw-font-semibold">{componentData[activePanelId].contentHeader}</span>
              <span className="tw-border tw-border-t tw-border-gray-200"></span>
              {componentData[activePanelId].lists.map((item) => (
                <span key={item} className="tw-flex tw-gap-2 tw-items-center">
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#101828">
                      <path d="m344-60-76-128-144-32 14-148-98-112 98-112-14-148 144-32 76-128 136 58 136-58 76 128 144 32-14 148 98 112-98 112 14 148-144 32-76 128-136-58-136 58Zm94-278 226-226-56-58-170 170-86-84-56 56 142 142Z" />
                    </svg>
                  </span>
                  <span className="tw-text-sm tw-font-normal tw-text-gray-900">{item}</span>
                </span>
              ))}
            </span>
            <span
              className="tw-flex tw-gap-1 tw-cursor-pointer tw-bg-primary-purple-500 tw-text-white tw-border-none tw-rounded-lg tw-w-fit tw-text-sm tw-font-semibold tw-px-4 tw-py-2"
              onClick={() => {
                handleUpgrade();
              }}>
              Upgrade Your Plan
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default FeatureBlockUI;
